import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Button } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import { FloatLabel } from 'primeng/floatlabel';
import { AuthService } from '../../services/auth.service';
import { NotificationService } from '../../../shared/services/notification.service';
import {NgIf} from '@angular/common';
import {finalize, take} from 'rxjs';
import {RoleEnum} from '../../../shared/contracts/role.interface';

@Component({
  selector: 'kc-login',
  standalone: true,
  imports: [
    Button,
    FormsModule,
    InputText,
    ReactiveFormsModule,
    FloatLabel,
    NgIf
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private notificationService: NotificationService
  ) {
    this.loginForm = this.initForm();
  }

  ngOnInit(): void {
    // Just to clean local storage
    this.authService.logout();

    // Check if user is already logged in
    if (this.authService.isLoggedIn()) {
      this.manageRouteByRole();
    }
  }

  private initForm(): FormGroup {
    return this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  onSubmit(): void {
    if (this.loginForm.valid) {
      this.isLoading = true;
      const { email, password } = this.loginForm.value;

      this.authService.login(email, password)
        .pipe(
          take(1),
          finalize(() => this.isLoading = false)
        )
        .subscribe( _ => {
            this.notificationService.success('Login effettuato con successo.');
            this.manageRouteByRole();
        });
    } else {
      this.loginForm.markAllAsTouched();
    }
  }

  manageRouteByRole() {
    if(localStorage.getItem('userRole') === RoleEnum.ADMIN) {
      this.router.navigate(['/tenants']);
    } else if (localStorage.getItem('userRole') === RoleEnum.SUPERVISOR){
      this.router.navigate(['/dashboard']);
    } else if (localStorage.getItem('userRole') === RoleEnum.OPERATOR){
      this.router.navigate(['/conversations']);
    }
  }
}
